// Promo 7 — "90-Day Challenge"
// Commit for 3 months → finish all 90 days → lock founding rate forever + month 4 free.
import { PromoStage, BgPhoto, PHOTOS, FULL_PB } from "@/pages/promo/_stage";
import { motion } from "framer-motion";

const SLIDES = [
  {
    id: "hook",
    duration: 2200,
    bg: "#0A0A0A",
    full: true,
    render: () => (
      <>
        <BgPhoto src={PHOTOS.hero} kenBurns="out" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/60 to-black/90" />
        <div className="absolute inset-0 flex flex-col justify-end px-16" style={{ paddingBottom: FULL_PB + 20 }}>
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} className="text-[#FF1B91] uppercase tracking-[0.5em] text-sm font-bold mb-5">
            / Announcing
          </motion.p>
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }} className="font-display font-black uppercase text-white leading-[0.85] tracking-tighter" style={{ fontSize: "200px" }}>
            The<br />
            <span className="text-[#FF1B91]">90-day</span><br />
            Slay.
          </motion.h1>
        </div>
      </>
    ),
  },
  {
    id: "what",
    duration: 2200,
    bg: "#FF1B91",
    render: () => (
      <div className="flex flex-col items-center justify-center w-full h-full text-center">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.4 }} className="text-white uppercase tracking-[0.5em] text-sm font-bold mb-6">
          / The challenge
        </motion.p>
        <motion.h2 initial={{ opacity: 0, scale: 0.85 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.6, delay: 0.15 }} className="font-display font-black uppercase text-white leading-[0.85] tracking-tighter" style={{ fontSize: "320px" }}>
          90<br />
          <span className="font-brush font-normal normal-case -rotate-3 inline-block" style={{ fontSize: "180px" }}>days.</span>
        </motion.h2>
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5, delay: 0.55 }} className="mt-6 text-white text-3xl font-bold uppercase tracking-tight">
          You commit. I deliver.
        </motion.p>
      </div>
    ),
  },
  {
    id: "you",
    duration: 2400,
    bg: "#0A0A0A",
    render: () => (
      <div className="flex flex-col justify-center w-full h-full">
        <motion.p initial={{ opacity: 0, x: -30 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.4 }} className="text-[#FF1B91] uppercase tracking-[0.4em] text-sm font-bold mb-6">
          / Your part
        </motion.p>
        {[
          "3 months. Locked in.",
          "Train the plan. Every week.",
          "Check in. Show up.",
        ].map((b, i) => (
          <motion.div
            key={b}
            initial={{ opacity: 0, x: 40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.4, delay: 0.2 + i * 0.18 }}
            className="flex items-center gap-5 py-4 border-b border-white/10"
          >
            <span className="font-display font-black text-[#FF1B91] text-3xl tracking-tighter w-12">0{i + 1}</span>
            <span className="font-display font-black uppercase text-white text-3xl tracking-tighter leading-[1.0]">{b}</span>
          </motion.div>
        ))}
      </div>
    ),
  },
  {
    id: "reward1",
    duration: 1800,
    bg: "#FF1B91",
    render: () => (
      <div className="flex flex-col items-center justify-center w-full h-full text-center">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.4 }} className="text-white uppercase tracking-[0.5em] text-sm font-bold mb-6">
          / Finish 90, you get
        </motion.p>
        <motion.h2 initial={{ opacity: 0, scale: 0.85 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.55, delay: 0.15 }} className="font-display font-black uppercase text-white leading-[0.85] tracking-tighter" style={{ fontSize: "180px" }}>
            Month 4<br />
          <span className="font-brush font-normal normal-case -rotate-3 inline-block" style={{ fontSize: "200px" }}>on me.</span>
        </motion.h2>
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5, delay: 0.5 }} className="mt-4 text-white text-2xl font-bold uppercase tracking-tight">
          $0. Programming included.
        </motion.p>
      </div>
    ),
  },
  {
    id: "reward2",
    duration: 2200,
    bg: "#0A0A0A",
    render: () => (
      <div className="flex flex-col items-center justify-center w-full h-full text-center">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.4 }} className="text-[#FF1B91] uppercase tracking-[0.5em] text-sm font-bold mb-6">
          / + this
        </motion.p>
        <motion.h2 initial={{ opacity: 0, scale: 0.85 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.55, delay: 0.15 }} className="font-display font-black uppercase text-white leading-[0.85] tracking-tighter" style={{ fontSize: "170px" }}>
          Founding rate<br />
          <span className="text-[#FF1B91]">locked for life.</span>
        </motion.h2>
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5, delay: 0.5 }} className="mt-6 text-white/75 text-xl leading-snug">
          Rates rise for everyone else.<br />Yours never moves.
        </motion.p>
      </div>
    ),
  },
  {
    id: "scarcity",
    duration: 1600,
    bg: "#FF1B91",
    render: () => (
      <div className="flex flex-col items-center justify-center w-full h-full text-center">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.4 }} className="text-white uppercase tracking-[0.5em] text-sm font-bold mb-6">
          / Cohort cap
        </motion.p>
        <motion.h2 initial={{ opacity: 0, scale: 0.85 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.5 }} className="font-display font-black uppercase text-white leading-[0.85] tracking-tighter" style={{ fontSize: "260px" }}>
          15 spots.
        </motion.h2>
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.4, delay: 0.4 }} className="mt-4 text-white text-2xl font-bold uppercase tracking-tight">
          That's it. Next round opens Q2.
        </motion.p>
      </div>
    ),
  },
  {
    id: "cta",
    duration: 2600,
    bg: "#0A0A0A",
    render: () => (
      <div className="flex flex-col items-center justify-center w-full h-full text-center">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.4 }} className="text-[#FF1B91] uppercase tracking-[0.5em] text-sm font-bold mb-10">
          / Claim a spot
        </motion.p>
        <motion.h2 initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.55 }} className="font-display font-black uppercase text-white leading-[0.85] tracking-tighter" style={{ fontSize: "200px" }}>
          Pull<br />
          <span className="font-brush font-normal normal-case text-[#FF1B91] -rotate-3 inline-block" style={{ fontSize: "220px" }}>up.</span>
        </motion.h2>
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5, delay: 0.7 }} className="mt-10 text-white text-3xl font-bold tracking-tight">
          sweatwithslay.com
        </motion.p>
      </div>
    ),
  },
];

export default function Promo7() { return <PromoStage slides={SLIDES} />; }
